import { forwardRef } from "react";
import classNames from "classnames";
import { Division, Heading } from "@ir/ui";

interface PageHeadingProps {
  title?: string;
  className?: string;
  children?: React.ReactNode;
  borderBottom?: boolean;
}

const PageHeading = forwardRef<HTMLDivElement, PageHeadingProps>(({ title, className, children, borderBottom = true }, ref) => {
  const mainContentHeaderClass = classNames("main-content-header bg-white", { "border-bottom-1 border-color-grey-50": borderBottom }, className);

  return (
    <Division className={mainContentHeaderClass} ref={ref}>
      {title && <Heading text={title} level={5} className="m-0 font-bold" />}
      {children}
    </Division>
  );
});

export default PageHeading;
